import React from 'react';
import { MapPin, Clock } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { temples } from '../data/mockData';
import { Card, CardContent } from './ui/card';

const Temples = () => {
  const { language, t } = useLanguage();

  return (
    <section id="temples" className="py-20 bg-gradient-to-b from-white to-orange-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <div className="flex items-center justify-center space-x-3 mb-4">
              <div className="h-px w-12 bg-orange-400" />
              <div className="w-2 h-2 rotate-45 bg-orange-400" />
              <div className="h-px w-12 bg-orange-400" />
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              {t('templesTitle')}
            </h2>
            <p className="text-lg text-gray-600">
              {t('templesSubtitle')}
            </p>
          </div>

          {/* Temples Grid */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {temples.map((temple, index) => (
              <Card 
                key={index}
                className="border-2 border-orange-100 hover:border-orange-300 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 bg-white group"
              >
                <CardContent className="p-6">
                  <div className="flex items-start justify-between mb-3">
                    <div className="flex-1">
                      <h3 className="text-lg font-bold text-gray-800 mb-2 group-hover:text-orange-600 transition-colors">
                        {temple.name[language]}
                      </h3>
                      <div className="flex items-center text-sm text-gray-600 space-x-2">
                        <Clock className="w-4 h-4 text-orange-500" />
                        <span>{t('walkingDistance')}: {temple.distance}</span>
                      </div>
                    </div>
                    <div className="w-10 h-10 rounded-full bg-gradient-to-br from-orange-500 to-red-500 flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                      <MapPin className="w-5 h-5 text-white" />
                    </div>
                  </div>
                  <div className="h-1 w-0 group-hover:w-full bg-gradient-to-r from-orange-400 to-red-400 transition-all duration-500 rounded-full" />
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Map Section */}
          <div className="mt-16 text-center">
            <p className="text-gray-600 mb-6">
              {language === 'bn' 
                ? 'সমস্ত মন্দির আমাদের হোমস্টে থেকে সহজেই পৌঁছানো যায়' 
                : 'All temples are easily accessible from our homestay'}
            </p>
            <div className="relative h-96 rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1707938292313-2e4b3eabc5a4?w=1200&q=80"
                alt="Vrindavan Temples"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent flex items-end p-8">
                <div className="text-white">
                  <h3 className="text-2xl font-bold mb-2">
                    {language === 'bn' ? 'বৃন্দাবনের হৃদয়ে' : 'In the Heart of Vrindavan'}
                  </h3>
                  <p className="text-orange-200">
                    {language === 'bn' 
                      ? 'সমস্ত প্রধান মন্দিরের কাছাকাছি' 
                      : 'Close to all major temples'}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Temples;
